export type DbPlayersDto = Record<string, PlayerDto>;

export type PlayerTeam = 'red' | 'blue' | 'green' | 'yellow' | 'orange' | 'purple' | 'pink' | 'black' | 'white' | 'gray';

export interface PlayerDto {
    uid: string;
    turnOrder: number;
    name: string;
    ready?: boolean;
    team?: PlayerTeam | '';
}

export class Player {
    public readonly id: string;
    public readonly uid: string;
    public readonly name: string;
    public readonly team: PlayerTeam;
    public readonly ready: boolean;
    public readonly turnOrder: number;
    public readonly isDeviceOwner: boolean = false;

    constructor(id: string, data: PlayerDto, isDeviceOwner?: boolean) {
        this.id = id;
        this.uid = id;
        this.name = data.name;
        this.turnOrder = data.turnOrder;
        this.team = data.team as PlayerTeam;
        this.ready = data.ready === true;

        if (isDeviceOwner === true) {
            this.isDeviceOwner = true;
        }
    }
}
